// The login link's page, /sign-in#token=<the login's token>&door=<the door> (CLAUDE.md, Security: "a
// link that lands on a page with a Log in button" ("Log in" everywhere, Adam, 11 Oct), "because work
// email scanners open links and use them up"; decision 41). request-code writes the link into the login code email
// (supabase/functions/request-code/link.ts); the token is the same login's as the email's code, so
// using either uses both. It's read from the part after the #, which a browser never sends to a
// server, and never from a query string: a token in a query string isn't taken. Plain data, no
// browser call, so the function tests can check the 2 sides agree.

export const SIGN_IN_PATH = '/sign-in'

// generateLink's hashed_token, as request-code accepts it for the link
const TOKEN = /^[A-Za-z0-9_-]{20,200}$/

// The product doors (config/doors.js); the Library's door is a link with no door
const DOORS = ['cashflow', 'poyt', 'masterclass', 'fe', 'acc']

// { token, door }: the token, or null when the link has none that could be 1; the door's key, or
// 'library' when it names none of the product doors
export function readLoginLink(hash) {
  let params
  try {
    params = new URLSearchParams(String(hash || '').replace(/^#/, ''))
  } catch {
    params = new URLSearchParams()
  }
  const token = params.get('token')
  const door = params.get('door')
  return {
    token: token && TOKEN.test(token) ? token : null,
    door: DOORS.includes(door) ? door : 'library',
  }
}

// Whether a refusal from verifyOtp means the link itself won't work again (used, run out, or not a
// token at all), rather than a failure worth trying again: no answer, Supabase's side, or too many
// tries in a row
export function linkIsGone(error) {
  if (!error) return false
  if (error.name === 'AuthRetryableFetchError') return false
  const status = Number(error.status)
  if (!Number.isFinite(status) || status === 0 || status === 429 || status >= 500) return false
  return status >= 400
}
